import React, { useState, useEffect, useRef } from "react";
import './ExportSheete.css'
import { useNavigate } from 'react-router-dom';
import { Button } from "antd";
import NipponLogo_N from '../../Assets/Nippon_N.png'
import { usePermitStore } from "../../Store/store";
import { format, parseISO, add } from "date-fns";
import { PDFExport } from "@progress/kendo-react-pdf";
import { AiOutlineCheck } from "react-icons/ai";

function ExportSheete() {
    const ref = React.createRef(null);
    const pdfExportComponent = useRef(null);
    const Navigate = useNavigate();
    const [LoginInfo, setLoginInfo] = useState();
    const ExportBasicDetail = usePermitStore((state) => state.ExportBasicDetail)
    const ExportPermitDetail = usePermitStore((state) => state.ExportPermitDetail)
    const ExportExtentionDetail = usePermitStore((state) => state.ExportExtentionDetail)
    const ExportPermitImgDetail = usePermitStore((state) => state.ExportPermitImgDetail);
    const ExportPermitApproval = usePermitStore((state) => state.ExportPermitApproval)
    const [FisrtExportPermitDatas, setFisrtExportPermitDatas] = useState([])
    const [SecondExportPermitDatas, setSecondExportPermitDatas] = useState([])

    useEffect(() => {
        setLoginInfo(JSON.parse(sessionStorage.getItem("UserInfo")))
    }, [])


    useEffect(() => {
        let ExportPermitDetailData = [...ExportPermitDetail]
        const middleIndex = Math.ceil(ExportPermitDetailData.length / 2);
        const firstHalf = ExportPermitDetailData.splice(0, Math.ceil(ExportPermitDetailData.length / 2));
        const secondHalf = ExportPermitDetailData.splice(-middleIndex);
        setFisrtExportPermitDatas(firstHalf)
        setSecondExportPermitDatas(secondHalf)
    }, [ExportPermitDetail])

    const printDocument = () => {
        if (pdfExportComponent.current) {
            pdfExportComponent.current.save();
        }
    }
    const RevertViewPermit = () => {
        if (LoginInfo.isApprover === true) {
            Navigate("/BasicPermit");
        } else {
            Navigate("/BasicPermit");
        }
    }

    const CheckBoxValueChack = (data) => {
        return data?.toString()?.toLowerCase() === "true" ? <AiOutlineCheck /> : ""
    }

    const headers = [
        "Emp ID", "Emp Name", "Status", "Approval Type", "Pending By", "Approval Level", "Approve/Reject Date"
    ];

    const data = ExportPermitApproval?.map(PermitData => [
        PermitData?.approvedByEmpID,
        PermitData?.approvedByName,
        PermitData?.status,
        PermitData?.approvalType,
        PermitData?.approvallBy ? PermitData.approvallBy.split(',').join(", ") : '',
        PermitData?.approvalLevel,
        PermitData?.appRejDate
            ? format(add(parseISO(PermitData.appRejDate), { hours: 5, minutes: 30 }), "dd/MM/yyyy hh:mm a")
            : ''
    ]) || [];

    const sortedData = data.sort((a, b) => {
        const approvalTypeA = a[3] || ''; // a[3] corresponds to approvalType
        const approvalTypeB = b[3] || ''; // b[3] corresponds to approvalType

        // If a is "Permit-Approval" and b is "Extension-Approval", a should come first
        if (approvalTypeA === 'Permit-Approval' && approvalTypeB !== 'Permit-Approval') return -1;
        // If b is "Permit-Approval" and a is "Extension-Approval", b should come first
        if (approvalTypeB === 'Permit-Approval' && approvalTypeA !== 'Permit-Approval') return 1;

        return 0; // If both have the same approvalType or are neither "Permit-Approval" nor "Extension-Approval"
    });

    const ChildCardFucntion = (data) => {
        let IsChildIsCheckBox = (data.map((Child) => Child.type?.toLowerCase())).includes("string")
        return <>
            {IsChildIsCheckBox ? data.map((PermitDataChild, index) => PermitDataChild.type === "bool" ?
                <div key={index} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 2px 6px 2px' }}>
                    <div style={{ textWrap: 'wrap', width: '90%' }}>{PermitDataChild.title}</div>
                    <div style={{ border: '1px solid gray', height: '13px', width: '13px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {CheckBoxValueChack(PermitDataChild.value)}
                    </div>
                </div>
                :
                <div key={index} style={{ display: 'flex', gap: '5px', flexDirection: 'row', justifyContent: 'start', padding: '2px 4px 4px 4px' }}>
                    <div style={{ textWrap: 'wrap', fontWeight: "bold" }}>{PermitDataChild.title} :</div>
                    <div>
                        {PermitDataChild.value}
                    </div>
                </div>
            ) : <div style={{ display: 'grid', gridTemplateColumns: data[1]?.title?.length > 30 ? 'auto' : 'auto auto auto auto', gap: '4px', padding: "0px 22px 0px 10px" }}>
                {data.map((PermitDataChild, index) =>
                    PermitDataChild.type === "bool" ?
                        <div key={index} style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ textWrap: 'wrap' }}>{PermitDataChild.title}</div>
                            <div style={{ border: '1px solid gray', height: '13px', width: '13px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {CheckBoxValueChack(PermitDataChild.value)}
                            </div>
                        </div>
                        :
                        <div key={index} style={{ display: 'flex', gap: '5px', flexDirection: 'row', justifyContent: 'start', padding: '2px 4px 4px 4px' }}>
                            <div style={{ textWrap: 'wrap', fontWeight: "bold" }}>{PermitDataChild.title} :</div>
                            <div>
                                {PermitDataChild.value}
                            </div>
                        </div>
                )}
            </div>
            }
        </>
    }
    return (
        <div ref={ref} className="Main_ExportSheete_Class" style={{ justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <PDFExport
                ref={pdfExportComponent}
                paperSize="a4"
                margin={10}
                fileName={`Report for ${ExportPermitImgDetail.permitNumber}`}
                author="KendoReact Team">
                <div className="row" style={{ marginLeft: '10px', marginRight: '10px' }} id="ExportDiv" >
                    <img className="image_N" src={NipponLogo_N} style={{ width: '70px' }} />
                    <div style={{ fontSize: "10px" }} className="col-md-12 Header1">
                        NIPPON PAINT (INDIA) PRIVATE LIMITED
                    </div>
                    <div style={{ display: 'flex', fontSize: '10px', fontWeight: 'bold', backgroundColor: ExportPermitImgDetail.permitColour, height: '22px', alignItems: 'center', justifyContent: "space-between" }}>
                        <div style={{ width: '200px' }}></div>
                        <div style={{ textAlign: "center", width: '200px' }}>{ExportPermitImgDetail?.permitType}</div>
                        <div style={{ textAlign: "end", fontSize: '9px', width: '200px' }}>Permit Number :{ExportPermitImgDetail.permitNumber}</div>
                    </div>
                    <div style={{ fontSize: "10px" }} className="row BorderLineClass1">
                        <div className="col-md-12 Header3 ">
                            Basic Details
                        </div>
                        <div className="wrapper" >
                            <div>
                                <label style={{ fontSize: "10px", fontWeight: "bold" }} >Plant :</label><br />
                                <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.plant}</label>
                            </div>
                            <div>
                                <label style={{ fontSize: "10px", fontWeight: "bold" }} >Area :</label><br />
                                <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.area}</label>
                            </div>
                            {ExportBasicDetail?.mentionArea && (
                                <div>
                                    <label style={{ fontSize: "10px", fontWeight: "bold" }} >Mention Area :</label><br />
                                    <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.mentionArea}</label>
                                </div>
                            )}
                            <div>
                                <label style={{ fontSize: "10px", fontWeight: "bold" }}  >Employee Name :</label><br />
                                <label style={{ fontSize: "10px" }} >{ExportBasicDetail?.name}</label>
                            </div>
                            <div>
                                <label style={{ fontSize: "10px", fontWeight: "bold" }} >Department :</label><br />
                                <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.departmentName}</label>
                            </div>
                            <div>
                                <label style={{ fontSize: "10px", fontWeight: "bold" }}>Contractor Name :</label><br />
                                <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.nameofEmployee}</label>
                            </div>
                            <div>
                                <label style={{ fontSize: "10px", fontWeight: "bold" }}>Permit Date :</label><br />
                                <label style={{ fontSize: "10px" }}>{format(parseISO(ExportBasicDetail?.issueDate), "dd/MM/yyyy")}</label>
                            </div>
                            <div>
                                <label style={{ fontSize: "10px", fontWeight: "bold" }}>Permit Start Time :</label><br />
                                <label style={{ fontSize: "10px" }}>{format(parseISO(ExportBasicDetail?.issueStartTime), "HH:mm")}</label>
                            </div>
                            <div>
                                <label style={{ fontSize: "10px", fontWeight: "bold" }}>Permit End Time :</label><br />
                                <label style={{ fontSize: "10px" }}>{format(parseISO(ExportBasicDetail?.issueEndTime), "HH:mm")}</label>
                            </div>
                            <div>
                                <label style={{ fontSize: "10px", fontWeight: "bold" }} >Number of person :</label><br />
                                <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.numberofPersons}</label>
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-6">
                                <label style={{ fontSize: "10px", fontWeight: "bold" }} >Name of Persons :</label><br />
                                <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.nameofPersons}</label>
                            </div>
                            <div className="col-6">
                                <label style={{ fontSize: "10px", fontWeight: "bold" }} >Description Of Work :</label><br />
                                <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.jobDescription}</label>
                            </div>
                        </div>
                    </div>

                    <div className="BorderLineClass1">
                        <div className="col-md-12 Header3 ">
                            Permit Details
                        </div>
                        <div style={{ fontSize: "10px", margin: "0% 0% 0% 0%" }} className="container">
                            <div className="column">
                                {FisrtExportPermitDatas.map((PermitData) =>
                                    <>
                                        {PermitData.type === "bool" ?
                                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 4px 6px 4px' }}>
                                                <div style={{ textWrap: 'wrap', width: '90%' }}>{PermitData.title}</div>
                                                <div style={{ border: '1px solid gray', height: '13px', width: '13px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    {CheckBoxValueChack(PermitData.value)}
                                                </div>
                                            </div>
                                            :
                                            <div style={{ display: 'flex', gap: "5px", flexDirection: 'row', justifyContent: 'space-between', padding: '6px 4px 6px 4px' }}>
                                                <div style={{ textWrap: 'wrap', width: '50%' }}>{PermitData.title}</div>
                                                <div style={{ width: '100%' }}>
                                                    {PermitData.value}
                                                </div>
                                            </div>
                                        }

                                        {PermitData.children.length > 0 ?
                                            ChildCardFucntion(PermitData.children) : ""}
                                        <div>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="column" style={{ height: '400px' }}>
                                {SecondExportPermitDatas.map((PermitData) =>
                                    <>
                                        {PermitData.type === "bool" ?
                                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px 4px 2px 4px' }}>
                                                <div style={{ textWrap: 'wrap', width: '90%' }}>{PermitData.title}</div>
                                                <div style={{ border: '1px solid gray', height: '13px', width: '13px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    {CheckBoxValueChack(PermitData.value)}
                                                </div>
                                            </div> :
                                            PermitData.type === "comment" ?
                                                <div style={{ display: 'flex', gap: "5px", flexDirection: 'row', justifyContent: 'space-between', padding: '6px 4px 6px 4px' }}>
                                                    <div style={{ textWrap: 'wrap', width: "50%" }}>{PermitData.title}</div>
                                                    <div style={{ width: '100%' }}>
                                                        {PermitData.value}
                                                    </div>
                                                </div> :
                                                <div style={{ display: 'flex', gap: "5px", flexDirection: 'row', justifyContent: 'space-between', padding: '6px 4px 6px 4px' }}>
                                                    <div style={{ textWrap: 'wrap', width: "50%" }}>{PermitData.title}</div>
                                                    <div style={{ width: '100%' }}>
                                                        {PermitData.value}
                                                    </div>
                                                </div>
                                        }
                                        {PermitData.children.length > 0 ?
                                            ChildCardFucntion(PermitData.children) : ""
                                        }
                                        <div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    {ExportExtentionDetail ?
                        <div className="BorderLineClass1">
                            <div style={{ fontSize: "10px", marginBottom: '-5px' }} className="col-md-12 Header3 ">
                                Extention Of The Permit
                            </div>
                            <p style={{ fontSize: "10px", marginBottom: '0px', display: 'flex', justifyContent: 'center' }}>
                                All the checks reviewed afresh & permit revalidated up to <b>&nbsp;{format(parseISO(ExportExtentionDetail?.extensionDate), "dd/MM/yyyy")}</b> Hrs, Date <b>&nbsp;{format(parseISO(ExportExtentionDetail?.extensionDate), "HH:mm")}</b> .</p>
                        </div> :
                        <div className="BorderLineClass1">
                            <div style={{ fontSize: "10px", marginBottom: '-5px' }} className="col-md-12 Header3 ">
                                Extention Of The Permit
                            </div>
                            <p style={{ fontSize: "10px", marginBottom: '0px', display: 'flex', justifyContent: 'center' }}> All the checks reviewed afresh & permit revalidated up to <b>&nbsp;............. </b> Hrs, Date <b>&nbsp;..............</b> .</p>
                        </div>
                    }

                    <div className="BorderLineClass1">
                        <div style={{ fontSize: "10px", paddingBottom: '0px' }} className="col-md-12 Header3 ">
                            Handover & Closure of the Permit
                        </div>
                        <div className="container1">
                            <div className="column1">
                                <p style={{ fontSize: "10px", marginBottom: '0px', marginLeft: " 1%" }}>Job is Completed at .................... Hrs and we hereby declare that all persons under my change are withdrawn, tools and equipment cleared from the area of work.</p>
                                <div className="SignAndNamePlantTag">
                                    <p style={{ fontSize: "10px", marginBottom: '0px' }}>Name & Sign of Receiver ................................</p>
                                </div>
                            </div>
                            <div className="column1">
                                <p style={{ fontSize: "10px", marginBottom: '0px', marginLeft: " 1%" }}>Job is Completed at .................... Hrs and we hereby declare that all persons under my change are withdrawn, tools and equipment cleared from the area of work.</p>
                                <div className="SignAndNameTag">
                                    <p style={{ fontSize: "10px", marginBottom: '0px' }}>Name & Sign of Shift Incharge ................................</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {ExportPermitImgDetail?.permitType === "Confined Space / Vessel Entry Permit" &&
                        <div className="BorderLineClass1" style={{ marginTop: "3px" }}>
                            <table style={{ width: "100%" }}>
                                <tr>
                                    <th style={{ textAlign: "center", width: "100px", fontSize: "10px" }}>S No</th>
                                    <th style={{ textAlign: "center", fontSize: "10px" }}>Name of the Personel</th>
                                    <th style={{ textAlign: "center", width: "150px", fontSize: "10px" }}>Time Of Entry</th>
                                    <th style={{ textAlign: "center", width: "150px", fontSize: "10px" }}>Time Of Exit</th>
                                </tr>
                                <tr>
                                    <td style={{ height: "60px" }}></td>
                                    <td style={{ height: "60px" }} ></td>
                                    <td style={{ height: "60px" }} ></td>
                                    <td style={{ height: "60px" }}></td>
                                </tr>
                            </table>
                        </div>
                    }
                    <div className="BorderLineClass1">
                        <div style={{ fontSize: "10px" }}>
                            <a style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>This Permit is approved by EHS Incharge and Plant Head / Corporate EHS Head.</a>
                            <a style={{ justifyContent: "start", marginLeft: "0%" }}><b>Special Instruction : </b>Incase of fire alarm all work must be stopped.The permit stands cancelled. All persons must leave work site & Proceed to safe Assembly point.</a>
                        </div>
                    </div>

                    <>
                        <div className="row" style={{ margin: "0px 10px 0px 0px", padding: "0px" }} ><br /><br /><br />
                            <img className="image_Nippon" src={NipponLogo_N} style={{ width: '70px' }} />
                            <div style={{ fontSize: "10px" }} className="col-md-12 Header1">
                                NIPPON PAINT (INDIA) PRIVATE LIMITED
                            </div>
                            <div style={{ display: 'flex', fontSize: '10px', fontWeight: 'bold', backgroundColor: ExportPermitImgDetail.permitColour, height: '22px', alignItems: 'center', justifyContent: "space-between" }}>
                                <div style={{ width: '200px' }}></div>
                                <div style={{ textAlign: "center", width: '200px' }}>{ExportPermitImgDetail?.permitType}</div>
                                <div style={{ textAlign: "end", fontSize: '9px', width: '200px' }}>Permit Number :{ExportPermitImgDetail.permitNumber}</div>
                            </div>
                            <div style={{ fontSize: "10px" }} className="row BorderLineClass1">
                                <div className="col-md-12 Header3 ">
                                    Basic Details
                                </div>
                                <div className="wrapper" >
                                    <div>
                                        <label style={{ fontSize: "10px", fontWeight: "bold" }} >Plant :</label><br />
                                        <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.plant}</label>
                                    </div>
                                    <div>
                                        <label style={{ fontSize: "10px", fontWeight: "bold" }} >Area :</label><br />
                                        <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.area}</label>
                                    </div>
                                    {ExportBasicDetail?.mentionArea && (
                                        <div>
                                            <label style={{ fontSize: "10px", fontWeight: "bold" }} >Mention Area :</label><br />
                                            <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.mentionArea}</label>
                                        </div>
                                    )}
                                    <div>
                                        <label style={{ fontSize: "10px", fontWeight: "bold" }}  >Employee Name :</label><br />
                                        <label style={{ fontSize: "10px" }} >{ExportBasicDetail?.name}</label>
                                    </div>
                                    <div>
                                        <label style={{ fontSize: "10px", fontWeight: "bold" }} >Department :</label><br />
                                        <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.departmentName}</label>
                                    </div>
                                    <div>
                                        <label style={{ fontSize: "10px", fontWeight: "bold" }}>Contractor Name :</label><br />
                                        <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.nameofEmployee}</label>
                                    </div>
                                    <div>
                                        <label style={{ fontSize: "10px", fontWeight: "bold" }}>Permit Date :</label><br />
                                        <label style={{ fontSize: "10px" }}>{format(parseISO(ExportBasicDetail?.issueDate), "dd/MM/yyyy")}</label>
                                    </div>
                                    <div>
                                        <label style={{ fontSize: "10px", fontWeight: "bold" }}>Permit Start Time :</label><br />
                                        <label style={{ fontSize: "10px" }}>{format(parseISO(ExportBasicDetail?.issueStartTime), "HH:mm")}</label>
                                    </div>
                                    <div>
                                        <label style={{ fontSize: "10px", fontWeight: "bold" }}>Permit End Time :</label><br />
                                        <label style={{ fontSize: "10px" }}>{format(parseISO(ExportBasicDetail?.issueEndTime), "HH:mm")}</label>
                                    </div>
                                    <div>
                                        <label style={{ fontSize: "10px", fontWeight: "bold" }} >Number of person :</label><br />
                                        <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.numberofPersons}</label>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <label style={{ fontSize: "10px", fontWeight: "bold" }} >Name of Persons :</label><br />
                                        <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.nameofPersons}</label>
                                    </div>
                                    <div className="col-6">
                                        <label style={{ fontSize: "10px", fontWeight: "bold" }} >Description Of Work :</label><br />
                                        <label style={{ fontSize: "10px" }}>{ExportBasicDetail?.jobDescription}</label>
                                    </div>
                                </div>
                            </div>
                            <h5>Approver List</h5>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                    <tr style={{ borderBottom: "2px solid #ccc" }}>
                                        {headers.map((header, index) => (
                                            <th key={index} style={{ textAlign: "center", border: "1px solid #ccc", padding: "8px", fontSize: "10px" }}>
                                                {header}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {sortedData.map((row, rowIndex) => (
                                        <tr key={rowIndex} style={{ borderBottom: "1px solid #ccc" }}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} style={{ textAlign: "center", border: "1px solid #ccc", padding: "8px", fontSize: "10px" }}>
                                                    {cell}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                    {/* {data.map((row, rowIndex) => (
                                        <tr key={rowIndex} style={{ borderBottom: "1px solid #ccc" }}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} style={{ textAlign: "center", border: "1px solid #ccc", padding: "8px", fontSize: "10px" }}>
                                                    {cell}
                                                </td>
                                            ))}
                                        </tr>
                                    ))} */}
                                </tbody>
                            </table>
                        </div>
                    </>
                </div>
            </PDFExport>
            <br />
            <div className="mb5">
                <div className="row" >
                    <div className="col-md-12">
                        <Button type="primary" onClick={() => printDocument()}>Export</Button>
                        <Button style={{ marginLeft: "8px" }} type="primary" onClick={() => RevertViewPermit()} danger>Cancel</Button>
                    </div>
                </div>
                <div style={{ float: 'right' }}>
                </div>
            </div>
        </div>
    )
}
export default ExportSheete;